import {Editor, Transforms} from 'slate';
import isVoidType from '../utils/isVoidType';

function onBackspaceAfterFormGroup (editor, event, selectionMeta) {
  const {
    isSelectionAtStartOfElement,
    isSelectionCollapsed,
    selectionStart,
    selectionStartElement,
    selectionStartElementPath,
    selectionStartTextNode,
  } = selectionMeta;

  if (
    event.key !== 'Backspace' ||
    !selectionStart ||
    !isSelectionAtStartOfElement ||
    !isSelectionCollapsed
  ) {
    return false;
  }

  const [previousElement] = Editor.previous(editor, {
    at: selectionStartElementPath,
  }) || [undefined, undefined];

  if (
    !previousElement ||
    previousElement.type !== 'form-group'
  ) {
    return false;
  }

  event.preventDefault();

  // Move cursor into the form group
  const distance = isVoidType(previousElement.children[1].type) ? 2 : 1;
  Transforms.move(editor, {
    distance,
    offset: 'line',
    reverse: true,
  });

  // Delete the previous element if it's an empty paragraph
  if (
    selectionStartElement.type === 'paragraph' &&
    selectionStartTextNode.text.trim() === ''
  ) {
    Transforms.removeNodes(editor, {
      at: selectionStartElementPath,
    });
  }

  return true;
}

export default onBackspaceAfterFormGroup;
